export const stringifyFalsies = (
  input: string | null | number | undefined,
): string => (typeof input !== "string" ? "" : input);
